import { formatMoney } from "~/utils/formatMoney"
import moment from "moment"

const ReservationCard = ({ reservationData, camp, isCollectingTax, isCollectingCreditCardFee }) => {
  const {
    arrival,
    departure,
    created_at,
    owed,
    paid,
    refunded,
    refunded_service_fee,
    taxes,
    net_received,
    credit_card_fees_collected,
    service_fee,
    stripe_fee,
    payment_mode,
    duration,
    site,
    name,
    email,
    phone,
    site_type,
    adults,
    kids,
    discount_type,
  } = reservationData

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-200">
      <div className="mb-3 pb-2 border-b border-gray-200">
        <h3 className="text-lg text-gray-900">{name}</h3>
        <p className="text-sm text-gray-600 font-semibold">
          {site} • {site_type}
        </p>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div>
          <p className="text-xs text-gray-500">Arrival</p>
          <p className="text-sm font-medium">{moment(arrival).format("MM/DD/YY")}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Departure</p>
          <p className="text-sm font-medium">{moment(departure).format("MM/DD/YY")}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Duration</p>
          <p className="text-sm font-medium">{duration}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Created</p>
          <p className="text-sm font-medium">{moment(created_at).format("MM/DD/YY")}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div>
          <p className="text-xs text-gray-500">Payment Mode</p>
          <p className="text-sm font-medium">{payment_mode}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Discount</p>
          <p className="text-sm font-medium">{discount_type || "-"}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div>
          <p className="text-xs text-gray-500">Adults</p>
          <p className="text-sm font-medium">{adults}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Kids</p>
          <p className="text-sm font-medium">{kids}</p>
        </div>
      </div>

      <div className="mb-3 pb-2 border-b border-gray-200">
        <div className="grid grid-cols-2 gap-2">
          <div>
            <p className="text-xs text-gray-500">Owed</p>
            <p className="text-sm font-medium">{owed > 0 ? formatMoney(owed, camp?.currency) : "-"}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Paid</p>
            <p className="text-sm font-medium">{paid > 0 ? formatMoney(paid, camp?.currency) : "-"}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Refunded</p>
            <p className="text-sm font-medium">{refunded > 0 ? formatMoney(refunded, camp?.currency) : "-"}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Service Fee</p>
            <p className="text-sm font-medium">{service_fee > 0 ? formatMoney(service_fee, camp?.currency) : "-"}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Refunded Service Fee</p>
            <p className="text-sm font-medium">
              {refunded_service_fee > 0 ? formatMoney(refunded_service_fee, camp?.currency) : "-"}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Stripe Fee</p>
            <p className="text-sm font-medium">{stripe_fee > 0 ? formatMoney(stripe_fee, camp?.currency) : "-"}</p>
          </div>
          {isCollectingTax && (
            <div>
              <p className="text-xs text-gray-500">Taxes</p>
              <p className="text-sm font-medium">{taxes > 0 ? formatMoney(taxes, camp?.currency) : "-"}</p>
            </div>
          )}
          {isCollectingCreditCardFee && (
            <div>
              <p className="text-xs text-gray-500">CC Fees</p>
              <p className="text-sm font-medium">
                {credit_card_fees_collected > 0 ? formatMoney(credit_card_fees_collected, camp?.currency) : "-"}
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-between items-center">
        <div>
          <p className="text-xs text-gray-500">Net Amount</p>
          <p className="text-base font-semibold text-gray-900">
            {net_received != null ? formatMoney(net_received, camp?.currency) : "-"}
          </p>
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-200">
        <div>
          <p className="text-xs text-gray-500">Contact</p>
          <p className="text-sm">{email}</p>
          <p className="text-sm">{phone}</p>
        </div>
      </div>
    </div>
  )
}

export default ReservationCard
